import * as utility from "../services"
import * as common_components from "../editor_common_components"
import * as react_components from "../reactcomponent"
import * as propertyTypes from "../property_types"
import { SqlParameter, SqlResultTable, SqlParameterState } from "./api_builder_common"
import * as uieditor from "../uieditor/ui_editor_detail"
import { Innosoft_InnoBI_Controllers_ApiBuilderController as ApiBuilderController } from "../generated_api/generated_api"
import { UiBuildertoolBar } from "../components/ui_builder_toolbar"
import { SavingDialog } from "../components/saving_dialog"
import { getGlobalSettings } from "../settings"
import { Menu, EntryType } from "../../core/components/menu"
import { NotificationHelper } from "../../core/util/notificationHelper"
import React from "react";
var sqlServiceEditor = {
    "rows": [
        {
            "type": "ROW", "rowItems": [
                { type: "CODEEDITOR", name: "GetQuery", header: "SQL-Service" }]
        }
    ]
};

export class RootQuery extends propertyTypes.Serializable {
    private NameMetadata = new propertyTypes.TextProperty("Name", "Name");
    public Name: string;

    private SqlQueryMetadata = new propertyTypes.TemplateProperty("SqlQuery", "SqlQuery");
    public SqlQuery: string;

    private ChildQueriesMetadata = new propertyTypes.ObjectListPropertyExt("ChildQueries", "Child queries").addStateImplementation("default", ChildQuery);
    public ChildQueries: ChildQuery;

    getMetadata(): propertyTypes.BaseProperty[] {
        return [this.NameMetadata, this.SqlQueryMetadata, this.ChildQueriesMetadata];
    }
}

export class ChildQuery extends propertyTypes.Serializable {
    private NameMetadata = new propertyTypes.TextProperty("Name", "Name");
    public Name: string;

    private SqlQueryMetadata = new propertyTypes.TemplateProperty("SqlQuery", "SqlQuery");
    public SqlQuery: string;

    private ConnectWithFieldMetadata = new propertyTypes.TextProperty("ConnectWithField", "Field name");
    public ConnectWithField: string;

    private ChildQueriesMetadata = new propertyTypes.ObjectListPropertyExt("ChildQueries", "Child queries").addStateImplementation("default", ChildQuery);
    public ChildQueries: ChildQuery;

    getMetadata(): propertyTypes.BaseProperty[] {
        return [this.NameMetadata, this.SqlQueryMetadata, this.ConnectWithFieldMetadata, this.ChildQueriesMetadata];
    }
}

export class ApiBuilderState extends propertyTypes.Serializable {
    private ParametersMetadata = new propertyTypes.ObjectListPropertyExt("Parameters", "Parameters").addStateImplementation("default", SqlParameterState);
    public Parameters: string;

    private translateValuesMetadata = new propertyTypes.CheckBoxProperty("translateValues", "Translate values");
    public TranslateValues: boolean;

    private RootQueriesMetadata = new propertyTypes.ObjectListPropertyExt("RootQueries", "Root queries").addStateImplementation("default", RootQuery);
    public RootQueries: RootQuery[];

    getMetadata(): propertyTypes.BaseProperty[] {
        return [this.ParametersMetadata, this.RootQueriesMetadata, this.translateValuesMetadata];
    }
}



export class HierarchicalServiceEditor extends React.Component<any, any>{
    private apiBuilderState: ApiBuilderState;
    private menuEntries;

    constructor(props) {
        super(props);

        this.apiBuilderState = new ApiBuilderState();
        this.apiBuilderState.hydrateFromJS(props.uiValues);

        this.state = { uiValues: props.uiValues, isSaving: false };
        this.menuEntries = [{ type: EntryType.Save, onClick: this.handleSave, show: this.canSaveApi() }];
    }

    handleTextChange = (name, value) => {
        this.state.uiValues[name] = value;
        this.setState({ uiValues: this.state.uiValues });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        var uiValues = nextProps.uiValues;

        if (uiValues == null) uiValues = {};
        if (uiValues.GetQuery === undefined) uiValues.GetQuery = null;
        if (uiValues.Parameters === undefined) uiValues.Parameters = null;
        this.apiBuilderState.hydrateFromJS(uiValues);
        this.setState({ uiValues: uiValues });
    }

    handleChanges = (object, propertyName, value) => {
        object[propertyName] = value;
        this.forceUpdate();
    }

    handleArrayChanged = (propertyName, newArray) => {
        var newState = Object.assign({}, this.state.uiValues);
        newState[propertyName] = newArray;
        this.setState({ uiValues: newState });
    }

    handleSettingsChanged = (newSettings) => {
        this.apiBuilderState.hydrateFromJS(newSettings);
        this.setState({ uiValues: newSettings });
    }

    handleSave = () => {
        new ApiBuilderController().Save(this.props.id, this.state.uiValues, (result) => {
            NotificationHelper.showSuccessMessage("Saved successfully");
        });
        this.setState({ isSaving: true });
    }

    handleCancel = () => {
        // this.history.pushState(null, '/apiBuilder');
    }

    canSaveApi = () => {
        if (getGlobalSettings().GetSettings().INNO_IS_INTERNAL_USER == 1) {
            return true;
        }
        else if (this.props.isInternal == 1) {
            return false;
        }
        return true;
    }

    showMenuOrWarning = () => {
        if (!this.canSaveApi()) {
            return <div style={{ backgroundColor: "red" }}>This is an internal api. Changes can not be saved. Please create a copy.</div>
        }
    }

    handleEval = () => { }

    render() {

        var ui = sqlServiceEditor;
        var editorForElement: any = this.apiBuilderState.getMetadata();
        return (
            <div>
                <Menu entries={this.menuEntries} onSelect={this.handleEval} enableMenuItem={() => true} handleEval={this.handleEval} />
                {this.showMenuOrWarning()}

                <div className="dashboardContent" style={{ left: "0px" }}>
                    <ul className="breadcrumb">
                        <ul>{this.props.name}</ul>
                    </ul>
                    <react_components.ReactDynamicUi uiDefinition={ui}
                        onTextChange={this.handleTextChange}
                        parameters={this.state.uiValues} />
                    <HierarchicalSqlExecutor serviceDefinition={this.state.uiValues} />
                </div>

                <div className="rightSidebar">
                    <react_components.SideBar header="PROPERTIES">
                        <ul className="list-group">
                            <common_components.PropertiesEditor key={this.state.selectedElement}
                                componentState={this.apiBuilderState}
                                properties={editorForElement}
                                selectedElement={this.state.uiValues}
                                onSettingsChanged={this.handleSettingsChanged}></common_components.PropertiesEditor>
                        </ul>
                    </react_components.SideBar>
                </div>
            </div>
        );
    }
};

interface IHierarchicalBaseQuery {
    Name: string,
    SqlQuery: String,
}

interface IHierarchicalRootQuery extends IHierarchicalBaseQuery {
    ChildQueries: IHierarchicalChildQuery[];
}

interface IHierarchicalChildQuery extends IHierarchicalRootQuery {
    ConnectWithField: string
}

interface IHierarchicalSqlExecutorState {
    selectedQuery?: string
    includeChildren?: boolean
    uiState?: string,
    errorMessage?: string,
    data?: any[],
    parameterValues?: any
}

class HierarchicalSqlExecutor extends React.Component<any, IHierarchicalSqlExecutorState>{
    constructor(props) {
        super(props);
        this.state = { selectedQuery: null, includeChildren: false };
    }

    handleExecuteSql = () => {
        var that = this;
        this.setState({ uiState: "loading" });

        new ApiBuilderController().ExecuteHierarchicalSql({ selectedQuery: this.state.selectedQuery, serviceDefinition: this.props.serviceDefinition, parameters: this.state.parameterValues, includeChildren: this.state.includeChildren }, (result) => {
            if (result.state == "success") {
                that.setState({ data: result.data, uiState: "loaded" });
            }
            else {
                that.setState({ uiState: "failure", errorMessage: result.errorMessage });
            }
        });
    }

    generateOptionsForChildQuery = (rootQueries: IHierarchicalChildQuery[]) => {
        const options = [];
        for (const q of rootQueries) {
            options.push(<option value={q.Name}>{q.Name}</option>);
        }
    }

    generateOptions = (rootQueries: IHierarchicalChildQuery[]) => {

        let options = [];
        if (!rootQueries) {
            return options;
        }
        for (const q of rootQueries) {
            options.push(<option value={q.Name}>{q.Name}</option>);
            if (q.ChildQueries) {
                const childOptions = this.generateOptions(q.ChildQueries);
                options = options.concat(childOptions);
            }
        }

        return options;
    }

    handleSelectedQueryChanged = (event) => {
        this.setState({ selectedQuery: event.target.value });
    }

    handleIncludeChildrenChanged = (event) => {
        this.setState({ includeChildren: event.target.checked });
    }

    handleParametersChanged = (name, value) => {
        var params = this.state.parameterValues || {};
        params[name] = value;
        this.setState({ parameterValues: params });
    }

    render() {
        let resultView = null;
        if (this.state.uiState == "loading") {
            resultView = <div>loading...</div>
        }
        else if (this.state.uiState == "loaded") {
            if (!this.state.includeChildren) {
                resultView = <SqlResultTable data={this.state.data} />;
            } else {
                resultView = <div style={{ height: "500px" }}>
                    <uieditor.UiBuilderEditor name="hAce" language="txt" code={JSON.stringify(this.state.data, null, 2) || ''} />
                </div>
            }
        }
        else if (this.state.uiState == "failure") {
            resultView = <div style={{ "backgroundColor": "white", "whiteSpace": "pre" }}>{this.state.errorMessage}</div>
        }
        const options = this.generateOptions(this.props.serviceDefinition.RootQueries);
        return (
            <div>
                <SqlParameter parameters={this.props.serviceDefinition.Parameters} parameterValues={this.state.parameterValues} onTextChange={this.handleParametersChanged} />
                <button onClick={this.handleExecuteSql}>Execute</button>
                <select value={this.state.selectedQuery} onChange={this.handleSelectedQueryChanged}>
                    <option value={null}></option>
                    {options}
                </select>
                Include children
                <input type="checkbox" checked={this.state.includeChildren} onChange={this.handleIncludeChildrenChanged} />
                {resultView}
            </div>)
    }
};